
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M23.25 9.75v12a1.5 1.5 0 0 1 -1.5 1.5H2.25a1.5 1.5 0 0 1 -1.5 -1.5v-15a1.5 1.5 0 0 1 1.5 -1.5h9","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m22.82 4.15 -6.51 8.56L12.7 14l0.23 -3.82 6.51 -8.56a2.11 2.11 0 0 1 3 -0.41h0a2.11 2.11 0 0 1 0.38 2.94Z","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M9 13.38A4.19 4.19 0 0 0 12.37 20a4.12 4.12 0 0 0 4.11 -3.94","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M8.27 15.52H6.21a1 1 0 0 1 -1 -1V9.73a1 1 0 0 1 1 -1H9","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    